module.exports = {"420528101":"龙舟坪镇","420528102":"高家堰镇","420528103":"磨市镇","420528104":"都镇湾镇","420528105":"资丘镇","420528106":"渔峡口镇","420528107":"榔坪镇","420528108":"贺家坪镇","420528201":"大堰乡","420528202":"鸭子口乡","420528203":"火烧坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420528.json
// module id = 1584
// module chunks = 0